module.exports = __webpack_public_path__ + "static/media/logo-invest.b71a6da6.svg";